// extracted by mini-css-extract-plugin
export default {"headerBlock":"device_headerBlock__3vQbr","wrapper":"device_wrapper__gGWFq"};